// AD-2370: the names say whose they are, in the words of the enquiry form's two sections, 'Enquirer Details' and
// 'Prospective Pupil Details'.
export const ENQUIRY_NAME_HEADERS = {
    enquirerForename: 'Enquirer Forename',
    enquirerSurname: 'Enquirer Surname',
    pupilForename: 'Pupil Forename',
    pupilSurname: 'Pupil Surname'
};
